module.exports = function() {
  return new Worker(__webpack_public_path__ + "ce3283adf1774027ff2f.worker.js");
};